<template>
	<div data-tour-scope="setting-communication">
		<v-main>
			<v-container fluid fill-height>
				<v-layout v-resize="onResize" justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title>{{ $vuetify.lang.t('$vuetify.front.subsetting.communication') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
							<v-spacer />
						</v-toolbar>


						<v-data-table
							:headers="headers"
							class="elevation-0 cellanowrap"
							:hide-default-header="isMobile || mobileCards"
							:class="{ mobile: isMobile, 'table-cards': mobileCards }"
							hide-default-footer
							disable-pagination
							disable-sort
							item-key="item._id"
							data-tour="table"
						>
							<template #body>
								<!-- telefono: il servizio diventa una card, la configurazione si apre dentro la card -->
								<tbody v-if="mobileCards" class="setcomm-cards">
									<tr v-for="s in servizi" :key="s.key">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card>
												<template #title>
													<span class="d-inline-flex align-center">
														<v-avatar size="24px" tile class="mr-2"><img :src="s.logo" :alt="s.nome" /></v-avatar>
														{{ s.nome }}
													</span>
												</template>
												<template #actions>
													<v-switch v-model="modello(s).active" color="primary" class="mt-0 pt-0 mr-2" hide-details @change="saveSetting(s.indice)" />
													<v-btn small icon color="primary" data-tour="expand" :title="checkpresenza(s.indice) ? 'Chiudi' : 'Impostazioni'" @click="extension(s.indice)">
														<v-icon>{{ checkpresenza(s.indice) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
													</v-btn>
												</template>
												<service-panel v-if="checkpresenza(s.indice)" :servizio="s" :modello="modello(s)" :intestazione="false" data-tour="settings" @save="saveSetting(s.indice)">
													<v-alert outlined text dense type="info" class="text-body-2 mb-4">
														Configurare il Webhook dell'app inserendo il seguente url di callback <b class="setcomm-url">https://api.azseller.app/api/v1/nocors/communication/whatsapp</b>.<br />
														Inserire come verifica token il valore <b>123456789</b>
													</v-alert>
													<template v-slot:azioni>
														<v-btn v-if="s.connessione" small outlined color="primary" @click="openConnectionCheck(s.connessione)"><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn>
														<v-spacer></v-spacer>
													</template>
												</service-panel>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="s in servizi">
										<tr :key="s.key" class="as-list-row" :class="{ 'as-list-row--open': checkpresenza(s.indice) }" @click="extension(s.indice)">
											<td class="pr-0" style="width: 40px">
												<v-btn small icon data-tour="expand" :title="checkpresenza(s.indice) ? 'Chiudi' : 'Impostazioni'" @click.stop="extension(s.indice)">
													<v-icon>{{ checkpresenza(s.indice) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
												</v-btn>
											</td>
											<td>
												<v-avatar size="32px" tile>
													<img :src="s.logo" :alt="s.nome" />
												</v-avatar>
												{{ s.nome }}
											</td>
											<td @click.stop>
												<v-switch v-model="modello(s).active" color="primary" class="mt-0" hide-details @change="saveSetting(s.indice)" />
											</td>
										</tr>
										<tr v-if="checkpresenza(s.indice)" :key="s.key + '-panel'" class="as-expanded">
											<td :colspan="headers.length" class="py-3">
												<service-panel :servizio="s" :modello="modello(s)" data-tour="settings" @save="saveSetting(s.indice)">
													<v-alert outlined text dense type="info" class="text-body-2 mb-4">
														Configurare il Webhook dell'app inserendo il seguente url di callback <b>https://api.azseller.app/api/v1/nocors/communication/whatsapp</b>.<br />
														Inserire come verifica token il valore <b>123456789</b>
													</v-alert>
													<template v-slot:azioni>
														<v-btn v-if="s.connessione" small outlined color="primary" @click="openConnectionCheck(s.connessione)"><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn>
														<v-spacer></v-spacer>
													</template>
												</service-panel>
											</td>
										</tr>
									</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>
		<TourOverlay :tour="tour"></TourOverlay>
		<marketplace-connection-check v-model="connectionCheck.open" :service="connectionCheck.service"></marketplace-connection-check>
	</div>
</template>

<script>
import Vue from 'vue';

import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { VueMaskDirective } from 'v-mask';
import { uuid } from 'vue-uuid';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import ServicePanel from './components/ServicePanel.vue';
import MarketplaceConnectionCheck from './components/MarketplaceConnectionCheck.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createCommunicationSettingsTourSteps, stopCommunicationSettingsTour } from './communication-settings-tour';

Vue.directive('mask', VueMaskDirective);

export default {
	name: 'Framework',
	components: {
		TourOverlay,
		KeyValueCard,
		ServicePanel,
		MarketplaceConnectionCheck,
	},
	setup() {
		return { tour: useTour(createCommunicationSettingsTourSteps(), { onStop: stopCommunicationSettingsTour }) };
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},

	filters: {
		fixed: function (value) {
			if (!+value) return '';
			return _.round(value, 2);
		},
	},
	data() {
		return {
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// riquadri di configurazione aperti (indice del servizio)
			selected: [],
			// verifica connessione: verifica le impostazioni salvate
			connectionCheck: { open: false, service: 'whatsapp' },
			headers: [{ text: '', sortable: false }, { text: 'Servizio', sortable: false }, { text: 'Status', sortable: false }],
			messages: {
				email: [],
				name: [],
				password: [],
			},

			isMobile: false,

			firebase: {
				active: false,
				setting: {
					apikey: '',
					operations: [],
				},
				type: 'communication',
				service: 'firebase',
			},
			whatsapp: {
				active: false,
				setting: {
					app_id: '',
					app_secret: '',
					phone_id: '',
					account_id: '',
					phone: '',
					token: '',
					expired: '',
					operations: [],
				},
				type: 'communication',
				service: 'whatsapp',
			},

			lists: [],

			// righe della tabella: indice = argomento di saveSetting/extension, key = oggetto in data
			servizi: [
				{
					indice: 1,
					key: 'whatsapp',
					connessione: 'whatsapp',
					nome: 'Whatsapp',
					logo: require('@/assets/images/communication/whatsapp.svg'),
					campi: [
						{ key: 'app_id', label: 'App ID' },
						{ key: 'app_secret', label: 'App Secret' },
						{ key: 'phone_id', label: 'Phone ID' },
						{ key: 'account_id', label: 'Account ID' },
						{ key: 'token', label: 'Token long lived', tipo: 'textarea', pieno: true },
						{ key: 'expired', label: 'Data scadenza GG/MM/YYYYY', mask: '##/##/####' },
						{ key: 'phone', label: 'Telefono con prefisso internazionale', mask: '+############' },
						{ key: 'operations', label: 'Operazioni', tipo: 'select', items: ['tracking', 'chat', 'coupon'], multiple: true, pieno: true },
					],
				},
			],
		};
	},


	async created() {
		this.setPreload(true);
		let promises = [];
		this.lists = ['firebase', 'whatsapp'];
		promises.push(this.fetchSettings());
		promises.push(this.fetchService(this.lists));
		await Promise.all(promises);
		this.setPreload(false);

		let firebase = _.find(this.getServices, set => {
			return set.service === 'firebase';
		});
		if (firebase) {
			this.firebase = {
				active: firebase.active,
				setting: {
					apikey: firebase.setting?.apikey ? firebase.setting.apikey : '',
					operations: firebase.setting?.operations ? firebase.setting.operations : '',
				},
				type: 'communication',
				service: 'firebase',
			};
		}

		let whatsapp = _.find(this.getServices, set => {
			return set.service === 'whatsapp';
		});
		if (whatsapp) {
			this.whatsapp = {
				active: whatsapp.active,
				setting: {
					app_id: whatsapp.setting?.app_id ? whatsapp.setting.app_id : '',
					app_secret: whatsapp.setting?.app_secret ? whatsapp.setting.app_secret : '',
					phone_id: whatsapp.setting?.phone_id ? whatsapp.setting.phone_id : '',
					account_id: whatsapp.setting?.account_id ? whatsapp.setting.account_id : '',
					phone: whatsapp.setting?.phone ? whatsapp.setting.phone : '',
					token: whatsapp.setting?.token ? whatsapp.setting.token : '',
					expired: whatsapp.setting?.expired ? whatsapp.setting.expired : '',
					operations: whatsapp.setting?.operations ? whatsapp.setting.operations : '',
				},
				type: 'communication',
				service: 'whatsapp',
			};
		}
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getSettings: 'settings/getSetting',
			getDrawerFilter: 'settings/getDrawerFilter',

			getServices: 'services/getServices',
		}),
	},

	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',
			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchSettings: 'settings/asyncFetchData',
			fetchService: 'services/getServiceFetch',

			destroyData: 'settings/destroyData',
			setSettings: 'settings/updateData',
			setService: 'services/updateData',
		}),

		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		async handleFileUpload(file) {
			if (file && file.name) {
				const formData = new FormData();
				formData.append('file', file, file.name);
				formData.append('uuid', uuid.v4());

				const response = await axios.post(`${this.getUrl}multimedias/uploadfile`, formData, {
					headers: {
						'Content-Type': 'multipart/form-data', // Imposta il tipo di contenuto
						Authorization: `Bearer ${this.getToken}`,
					},
				});

				this.firebase.setting.apikey = response.data.url;
				this.$forceUpdate();
				//payload.value['sitemaps'].push(image);
			}
			/*if (this.amazonpay.setting?.pem) {
        console.log('File caricato:', this.amazonpay.setting.pem);
      }*/
		},
		async saveSetting(item) {
			let payload;

			switch (item) {
				case 0: {
					payload = this.firebase;
					this.setPreload(true);
					break;
				}

				case 1: {
					payload = this.whatsapp;
					this.setPreload(true);
					break;
				}
			}
			let url = 'services/update';
			axios
				.post(`${this.getUrl}${url}`, payload, {
					headers: { Authorization: `Bearer ${this.getToken}` },
				})
				.then(({ data }) => {
					this.setService(data.data);
					this.setPreload(false);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.setPreload(false);
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		extension(item) {
			let check = this.selected.includes(item);
			if (!check) {
				this.selected.push(item);
			} else {
				let index = this.selected.indexOf(item);
				this.selected.splice(index, 1);
			}
		},
		openConnectionCheck(service) {
			this.connectionCheck.service = service;
			this.connectionCheck.open = true;
		},
		checkpresenza(item) {
			return this.selected.includes(item);
		},
		// oggetto in data del servizio: created() lo sostituisce, quindi va letto ogni volta
		modello(servizio) {
			return this[servizio.key];
		},
	},
};
</script>

<style></style>

<style scoped>
/* lista compatta: la riga aperta si colora e sotto compare il riquadro di configurazione */
.as-list-row {
	cursor: pointer;
}
.as-list-row--open,
.as-list-row--open:hover {
	background: #f3f6fa !important;
}
.as-expanded,
.as-expanded:hover {
	background: transparent !important;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.setcomm-cards,
.setcomm-cards tr {
	display: block;
	width: 100%;
}
.setcomm-cards tr,
.setcomm-cards tr:hover {
	background: transparent !important;
}
.setcomm-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.setcomm-cards tr:first-child td {
	padding-top: 12px !important;
}
.setcomm-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.setcomm-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* card in lista fuori da v-data-table */
.kv-list > .kv-card + .kv-card {
	margin-top: 8px;
}
/* url di callback lunghi: vanno a capo dentro la card */
.setcomm-url {
	word-break: break-all;
}
</style>
